import { Button, Grid, Typography } from '@material-ui/core/';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendCode, verifyCode } from '~/store/legacy/actions/userActions.js';
import { useAppConfig } from '~/hooks/useAppConfig.js';
import { getUserStore, selectUser } from '~/store/legacy/selector/userSelectors';
import { toSupportedCountryAbbreviation } from '~/utils/format';
import ChowbusForm from '~/components/ChowbusForm';
import InternationalPhoneInput from '~/components/ChowbusForm/InternationalPhoneInput';
import useStyles from './PhoneVerification.style.js';

const PhoneVerification = () => {
  const [classes, dispatch] = [useStyles(), useDispatch()];
  const { codeSent } = useSelector(getUserStore);
  const user = useSelector(selectUser);
  const [phoneNumber, setPhoneNumber] = useState(user.phone_number);
  const appConfig = useAppConfig();
  const userServiceRegion =
    !appConfig.isLoading && user?.serviceRegionId
      ? appConfig.serviceRegions[user.serviceRegionId]
      : null;

  const [valid, setValid] = useState(false);

  useEffect(() => {
    if (user.phone_number) {
      dispatch(sendCode(user.phone_number));
    }
  }, []);

  const inputs = [React.createRef(), React.createRef(), React.createRef(), React.createRef()];

  const onChange = () => {
    const element = inputs.find((input) => !input.value);
    if (element) {
      element.focus();
    }
    setValid(!element);
  };

  const handlePhoneNumberChange = (e) => {
    if (!e) {
      return;
    }

    const {
      target: { value: number },
    } = e;

    setValid(number && ChowbusForm.validators.i18nPhoneNumberValidator(number) === null);
    setPhoneNumber(number && number.number);
  };

  const sendVerficationCode = () => {
    dispatch(sendCode(phoneNumber));
  };

  const verify = () => {
    const code = [inputs[0].value, inputs[1].value, inputs[2].value, inputs[3].value].join('');
    dispatch(verifyCode(code));
  };

  return (
    <Grid container justify='center'>
      <Grid item xs={10}>
        {codeSent && (
          <Typography variant='body1' align='center' className={classes.formField}>
            We sent a code to your phone <b>{user.phone_number}</b>. You may receive it in a mintue,
            please enter the code below
          </Typography>
        )}
        {!user.phone_number && !codeSent && (
          <Grid container justify='center'>
            <Typography variant='body1' align='center' className={classes.formField}>
              We will send a code to you phone, and you could use that code to verify
            </Typography>
            <InternationalPhoneInput
              onChange={handlePhoneNumberChange}
              variant='signup'
              country={toSupportedCountryAbbreviation(userServiceRegion?.country || '')}
            />
          </Grid>
        )}
        {codeSent && (
          <Grid container className={classes.formField}>
            <Grid item xs={3} className={classes.withDivider}>
              <ChowbusForm.Input
                passRef={(ref) => (inputs[0] = ref)}
                outlinedClass={classes.rightBoard}
                inputClass={classes.input}
                maxLength={1}
                type='text'
                require
                disableUnderline
                required
                onChange={onChange}
                fullWidth
                name='1'
              />
            </Grid>
            <Grid item xs={3} className={classes.withDivider}>
              <ChowbusForm.Input
                passRef={(ref) => (inputs[1] = ref)}
                outlinedClass={classes.middleBoard}
                inputClass={classes.input}
                maxLength={1}
                type='text'
                require
                disableUnderline
                required
                onChange={onChange}
                fullWidth
                name='2'
              />
            </Grid>
            <Grid item xs={3} className={classes.withDivider}>
              <ChowbusForm.Input
                passRef={(ref) => (inputs[2] = ref)}
                outlinedClass={classes.middleBoard}
                inputClass={classes.input}
                maxLength={1}
                type='text'
                require
                disableUnderline
                required
                onChange={onChange}
                fullWidth
                name='3'
              />
            </Grid>
            <Grid item xs={3}>
              <ChowbusForm.Input
                passRef={(ref) => (inputs[3] = ref)}
                outlinedClass={classes.leftBoard}
                inputClass={classes.input}
                maxLength={1}
                type='text'
                require
                disableUnderline
                required
                onChange={onChange}
                fullWidth
                name='4'
              />
            </Grid>
          </Grid>
        )}
        {codeSent && phoneNumber && <Button onClick={sendVerficationCode}>Resend code</Button>}
        <Grid container justify='center' style={{ marginTop: '40px' }}>
          {codeSent && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              disabled={!valid}
              onClick={verify}>
              Verify
            </Button>
          )}
          {!codeSent && (
            <Button
              variant='contained'
              color='primary'
              size='large'
              disabled={!valid}
              onClick={sendVerficationCode}>
              Send code
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PhoneVerification;
